module.exports = __webpack_public_path__ + "static/media/8OLA28.07ef5450.jpg";